// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Index_wrapper_1nXRC","customSvgIcon":"Index_customSvgIcon_3R9kx"};